import React from "react";
import SideNavLink from "./sideNavLink";

const SideNavExpandableList = ({ title, icon, list }) => {
  return (
    <li className="sidenav-item">
      <a href="javascript:void(0)" className="sidenav-link sidenav-toggle">
        {icon}
        <div>{title}</div>
      </a>

      <ul className="sidenav-menu">
        {list.map((obj, index) => {
          return <SideNavLink key={index} title={obj.title} link={obj.link} />;
        })}
      </ul>
    </li>
  );
};

export default SideNavExpandableList;



// WEBPACK FOOTER //
// ./src/views/components/sidenav/sideNavExpandableList.js